import { render } from "./Boardcast.vue?vue&type=template&id=5e571b8c"
import script from "./Boardcast.vue?vue&type=script&lang=js"
export * from "./Boardcast.vue?vue&type=script&lang=js"

import "./Boardcast.vue?vue&type=style&index=0&id=5e571b8c&lang=css"

import exportComponent from "D:\\Programming\\dashboard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__